// @flow

import { useMemo } from 'react';
import { usePolling } from './use-polling';
import type { QueryResult } from './use-polling';
import type { PaymentAction } from '../context';

function handleAssertionResult(result: QueryResult, dispatch: (PaymentAction) => void): boolean {
  if (result.status === 'SUCCESS' && result.assertion_options) {
    dispatch({
      type: 'ASSERTION_OPTIONS_RECEIVED',
      assertionOptions: result.assertion_options,
      redirectUrlAfterPayment: result.redirect_url_after_payment ?? null,
    });
    return true;
  }

  if (result.status === 'SUCCESS' && !result.assertion_options) {
    dispatch({ type: 'SET_ERROR', errorMessage: 'Erro ao consultar pagamento.' });
    return true;
  }

  if (result.status === 'ERROR') {
    dispatch({ type: 'SET_ERROR', errorMessage: result.status_message || 'Erro ao consultar pagamento.' });
    return true;
  }

  return false;
}

export function useAssertionOptions() {
  const config = useMemo(() => ({
    activeState: 'LOADING',
    onResult: handleAssertionResult,
    timeoutMessage: 'Tempo limite atingido. Tente novamente.',
  }), []);

  usePolling(config);
}
